import config from '@/common/config'
import axios from 'axios';

export default {
    setStorage: setStorage, // 设置本地存储
    getStorage: getStorage, // 根据key值获取
    clearStorage: clearStorage, // 根据key值清楚
    cleanStorageAll: cleanStorageAll, // 清楚所有本地存储
    ajax: ajax,
    // Axios,
    getQueryVariable: getQueryVariable,
    isMobile: isMobile,
    apiMessages: apiMessages,
    getLastTradingDay: getLastTradingDay,
    manyPOST: manyPOST
}

// 设置本地存储
function setStorage(key, value) {
    if (typeof(value) === 'object') {
        value = JSON.stringify(value)
    }
    localStorage.setItem(key, value)
}
// 获取本地存储
function getStorage(key) {
    var result = localStorage.getItem(key)
    if (result != "") {
        return JSON.parse(result)
    } else {
        return result;
    }
}
// 根据key值清楚本地存储
function clearStorage(key) {
    localStorage.removeItem(key)
}
// 清楚所有本地存储
function cleanStorageAll() {
    localStorage.clear()
}

// AJAX请求
function ajax(method, url, data, timeout, notoken) {
    return new Promise((resolve, reject) => {
        //var token = getStorage('token');
        var headers = {};
        if (method == 'POST' || method == "PUT") {
            axios({
                method,
                url,
                data,
                // headers
            }).then(response => {
                resolve(response.data);
            }, err => {
                reject(err);
            });
        } else if (method == "GET") {
            if (url.indexOf('sales_information') != -1) {
                headers = {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*'
                }
            }
            axios.get(url, {
                params: data,
                headers: headers
            }).then(response => {
                resolve(response.data);
            }, err => {
                reject(err);
            });
        } else {
            axios({
                method,
                url,
                data,
                headers
            }).then(response => {
                resolve(response.data);
            }, err => {
                reject(err);
            });
        }
    })
}

function manyPOST(requests) {
  if (!Array.isArray(requests)) {
      return Promise.reject(new Error('参数必须是请求数组'));
    }

  const requestPromises = requests.map(req => {
    return axios({
      method: 'POST',
      url: req.url,
      data: req.params
    })
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
  });

  return Promise.all(requestPromises);
}

function apiMessages(apiParam, source, sver_id_list) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'POST',
            url: "http://cjs-pro-message.zqf.com.cn/api/messages",
            data: {
                "body": JSON.stringify(apiParam),
                "sver_id_list": sver_id_list,
                "source": source
            }
        }).then(response => {
            resolve(response.data);
        }, err => {
            reject(err);
        });
    });
}

function Axios(method, url, data, timeout) {
    return new Promise((resolve, reject) => {
        if (method == 'POST') {
            axios.post(url, data, {
                headers: {
                    'toKen': "",
                    'Content-Type': 'application/json'
                }
            }).then(response => {
                resolve(response.data);
            }, err => {
                reject(err);
            });
        } else if (method == "GET") {
            axios.get(url, {
                params: data
            }).then(response => {
                resolve(response.data);
            }, err => {
                reject(err);
            });
        } else if (method == "PUT") {
            axios.put(url, data, {
                headers: {
                    'toKen': "",
                    'Content-Type': 'application/json'
                }
            }).then(response => {
                resolve(response.data)
            })
        } else {
            axios({
                method,
                url,
                data
            }).then(response => {
                resolve(response.data);
            }, err => {
                reject(err);
            });
        }
    })
}

function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return (false);
}


//判断访问类型是电脑还是手机
function isMobile() {
    var userAgentInfo = navigator.userAgent;

    var mobileAgents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];

    var mobile_flag = false;

    //根据userAgent判断是否是手机
    for (var v = 0; v < mobileAgents.length; v++) {
        if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
            mobile_flag = true;
            break;
        }
    }

    var screen_width = window.screen.width;
    var screen_height = window.screen.height;

    //根据屏幕分辨率判断是否是手机
    if (screen_width < 500 && screen_height < 800) {
        mobile_flag = true;
    }

    return mobile_flag;
}


//交易上个交易日
async function getLastTradingDay(day) {
    return new Promise((resolve, reject) => {
        day = day || 1
        axios.get('https://copernicus.cjs.com.cn/previous_trading_day_list/' + day, {
            params: {}
        }).then(function(response) {
            if (response) {
                resolve(response)
            } else {
                utils.setStorage(dateStr, false);
                resolve(false)
            }
        })
    })
}
